module.exports = "//static.hsappstatic.net/conversations-visitor-experience-components/static-1.22842/img/visitor-widget/ai-avatar.png"